import { useEffect } from 'react'

export const UNSAVED_DIALOG_MESSAGE = 'Bạn có dữ liệu chưa lưu. Bạn có muốn đóng hộp thoại không?'

export function shouldCloseDialog(
  hasUnsavedChanges: boolean,
  confirmDiscard: (message: string) => boolean = (message) => window.confirm(message),
): boolean {
  return !hasUnsavedChanges || confirmDiscard(UNSAVED_DIALOG_MESSAGE)
}

export function useEscapeClose({
  enabled,
  hasUnsavedChanges,
  onClose,
}: {
  enabled: boolean
  hasUnsavedChanges: boolean
  onClose: () => void
}): void {
  useEffect(() => {
    if (!enabled) return

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key !== 'Escape') return
      if (!shouldCloseDialog(hasUnsavedChanges)) return
      event.preventDefault()
      onClose()
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [enabled, hasUnsavedChanges, onClose])
}
